import type { Tag } from '~/ducks/asset-tags/data/Tag';
import type { TagState } from '~/ducks/asset-tags/data/TagState';

export const findCategoryIndexById = (draft: TagState, id: string) =>
  draft.availableTagCategories!.findIndex((tc) => tc.id === id);

export const updateTag = (
  draft: TagState,
  categoryId: string,
  tagId: string,
  newValues?: Partial<Tag>
) => {
  const categoryIndex = findCategoryIndexById(draft, categoryId);
  const tagIndex = draft.availableTagCategories![categoryIndex]?.tags.findIndex(
    (t) => t.id === tagId
  );
  if (categoryIndex < 0 || tagIndex < 0) {
    return;
  }
  if (newValues) {
    draft.availableTagCategories![categoryIndex].tags[tagIndex] = {
      ...draft.availableTagCategories![categoryIndex].tags[tagIndex],
      ...newValues,
    };
  } else {
    draft.availableTagCategories![categoryIndex].tags.splice(tagIndex, 1);
  }
};
